<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header :pageId="this.$options.name" />

    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Search Box -->
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PORTL')" />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              :selected="portal"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              :option-list="portalList"
              @list-clicked="onPortalSelect"
            />
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-7" />
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :columnsautoresize="true"
        :multiselect="false"
        :dataset="'ds0'"
        :initialPagesize="10"
        :showDisplayCountControl="false"
        :autoheight="false"
        :pageable="false"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:create="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onNewAndCancelClick"
        >
          {{ $t('MSG_BTN_RGST') }}
        </sui-button>
      </div>
      <sui-popup
        v-model="isShownPopupNew"
        :title="popTitleNew"
      >
        <p01
          :pageId="this.$options.name"
          :updateFlag="false"
          :title="title"
          :policyTypeCode="policyTypeCode"
          @onCloseClick="onNewAndCancelClick"
          @research="research"
        />
      </sui-popup>
      <sui-popup
        v-model="isShownPopupMod"
        :title="popTitleMod"
      >
        <p01
          :pageId="this.$options.name"
          :updateFlag="true"
          :title="title"
          :policyTypeCode="policyTypeCode"
          :persInfoProcPolicyUid="persInfoProcPolicyUid"
          @onCloseClick="onModAndCancelClick"
          @research="research"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import p01 from './components/PGE_CMP_00004_P01';
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMP_00004', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  data() {
    return {
      policyTypeCode: '',
      popTitleNew: this.$t('MSG_TIT_PERS_INFO_PROC_POLI_RGST'),
      popTitleMod: this.$t('MSG_TIT_PERS_INFO_PROC_POLI_MDFC'),
      title: this.$t('MSG_TXT_PERS_INFO_PROC_POLI'),
      portal: {
        key: '',
        label: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_PORTL_ID'),
        datafield: 'portalId',
        width: '100px',
      },
      {
        text: this.$t('MSG_TXT_PORTL_NM'),
        datafield: 'portalNm',
        width: '100px',
      },
      {
        text: this.$t('MSG_TXT_DOC_VER'),
        datafield: 'persInfoProcPolicyVer',
        width: '100px',
      },
      {
        text: this.$t('MSG_TXT_DOC_TTL'),
        datafield: 'policyDocumentTitle',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onGridSingleButtonClicked,
            type: 'link',
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_NCSR_YN'),
        datafield: 'ncsrYn',
        width: '100px',
      },
      {
        text: this.$t('MSG_TXT_START_DATE'),
        datafield: 'displayStartDT',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.ds0, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: '90px',
      },
      {
        text: this.$t('MSG_TXT_END_DATE'),
        datafield: 'displayFinishDT',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.ds0, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),        
        width: '90px',
      },
      {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'm_userName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              userId: 'finalModificationUserId',
              displayLanguageId: 'm_dsplLngId',
              knoxId: 'm_knoxId',
              userName: 'm_userName',
              userGlobalName: 'm_userGlobalName',
              departmentName: 'm_departmentName',
              departmentEnglishName: 'm_departmentEnglishName',
              loginId: 'm_loginId',
            },
          }, this.ds0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      },
      {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.ds0, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),        
        width: '150px',
      }],
      isShownPopupNew: false,
      isShownPopupMod: false,
      persInfoProcPolicyUid: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'deleteYn', map: 'deleteYn' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'firstRegistrationProgramId', map: 'firstRegistrationProgramId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'finalModificationProgramId', map: 'finalModificationProgramId' },
      { type: 'string', name: 'originalFinalModificationDTM', map: 'originalFinalModificationDTM' },
      { type: 'string', name: 'persInfoProcPolicyUid', map: 'persInfoProcPolicyUid' },
      { type: 'string', name: 'policyTypeCode', map: 'policyTypeCode' },
      { type: 'string', name: 'persInfoProcPolicyDT', map: 'persInfoProcPolicyDT' },
      { type: 'string', name: 'persInfoProcPolicyVer', map: 'persInfoProcPolicyVer' },
      { type: 'string', name: 'displayStartDT', map: 'displayStartDT' },
      { type: 'string', name: 'displayFinishDT', map: 'displayFinishDT' },
      { type: 'string', name: 'persInfoProcPolicyContent', map: 'persInfoProcPolicyContent' },
      { type: 'string', name: 'portalId', map: 'portalId' },
      { type: 'string', name: 'portalNm', map: 'portalNm' },
      { type: 'string', name: 'policyDocumentTitle', map: 'policyDocumentTitle' },
      { type: 'string', name: 'dataset-row-id', map: 'dataset-row-id' },
      { type: 'string', name: 'm_dsplLngId', map: 'm_dsplLngId' },
      { type: 'string', name: 'm_knoxId', map: 'm_knoxId' },
      { type: 'string', name: 'm_loginId', map: 'm_loginId' },
      { type: 'string', name: 'm_userName', map: 'm_userName' },
      { type: 'string', name: 'm_userGlobalName', map: 'm_userGlobalName' },
      { type: 'string', name: 'm_departmentName', map: 'm_departmentName' },
      { type: 'string', name: 'm_departmentEnglishName', map: 'm_departmentEnglishName' },
      { type: 'string', name: 'ncsrYn', map: 'ncsrYn' },
    ],
  }],
  created() {
    this.portalList = [];
  },
  mounted() {
    this.$nextTick(() => {
      this.loadPortalList().then(() => {
        this.searchAction();
      });
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadPortalList() {
      return new Promise((resolve, reject) => {
        this.policyTypeCode = utils.getParameter(this, 'policyTypeCode');

        if (utils.isEmpty(this.policyTypeCode)) {
          this.policyTypeCode = 'P';
        } else if (this.policyTypeCode === 'T') {
          this.popTitleNew = this.$t('MSG_TIT_TERMS_SERV_RGST');
          this.popTitleMod = this.$t('MSG_TIT_TERMS_SERV_MDFC');
          this.title = this.$t('MSG_TXT_TERMS_SERV');
        } else {
          this.popTitleNew = this.$t('MSG_TIT_OPERATION_POLICY_RGST');
          this.popTitleMod = this.$t('MSG_TIT_OPERATION_POLICY_MDFC');
          this.title = this.$t('MSG_TXT_OPERATION_POLICY');
        }

        http.request(this.contextPageId, 'DTS_CMP_00004')
          .then(res => {
            this.portalList = [];
            utils.forEach(res.data, obj => {
              this.portalList.push({
                key: obj.portalId,
                label: obj.portalName,
              });
            });
            this.portal = {
              key: '',
              label: '',
            };
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject();
          });
      });
    },
    getSearchData() {
      return {
        portalId: this.portal.key,
        policyTypeCode: this.policyTypeCode,
      };
    },
    onPortalSelect() {
      this.searchAction();
    },
    searchAction() {
      const searchData = this.getSearchData();
      http.request(this.$options.name, 'DTS_CMP_00013', {
        query: searchData,
      }).then(res => {
        this.ds0.setRawData(this.setUserInfoFormat(res.data));
      }).catch(error => {
        console.log(error);
      });
    },
    setUserInfoFormat(list) {
      utils.forEach(list, data => {
        utils.forEach(data.finalModificationUserInfo, (value, key) => {
          utils.set(data, `m_${key}`, value);
        });
      });
      return list;
    },
    onGridSingleButtonClicked(value, dataRow) {
      // alert(11);
      const { persInfoProcPolicyUid } = dataRow;
      this.persInfoProcPolicyUid = persInfoProcPolicyUid;
      this.onModAndCancelClick();
    },
    onPopupClose() {},
    onNewAndCancelClick() {
      this.isShownPopupNew = !this.isShownPopupNew;
    },
    onModAndCancelClick() {
      this.persInfoProcPolicyUid = this.isShownPopupMod ? '' : this.persInfoProcPolicyUid;
      this.isShownPopupMod = !this.isShownPopupMod;
      if (!this.isShownPopupMod) {
        this.ds0.clearSelection();
      }
    },
    research() {
      if (this.isShownPopupNew) {
        this.onNewAndCancelClick();
      }
      if (this.isShownPopupMod) {
        this.onModAndCancelClick();
      }
      this.searchAction();
    },
    // onExcelDownloadClick() {
    //   utils.downloadGridToExcel(this.$options.name, this.gridColumns0, this.ds0, 'persInfoProcPolicyList.xlsx');
    // },
  },
};
</script>
<style scoped>
</style>
